import Page from "../components/common/page";
import Reveal from "../components/common/reveal";
import { BOOKS } from "../data/books";
import { PAPERS_BY_YEAR, PUBLICATIONS_INTRO } from "../data/publications";
// import { SITE } from "../data/site";

const CompactBook = ({ book }) => (
	<div
		style={{
			flex: "1 1 320px",
			minWidth: "240px",
			display: "flex",
			gap: "24px",
		}}
	>
		{book.cover ? (
			<img
				src={process.env.PUBLIC_URL + book.cover}
				alt={book.title}
				className="book-cover-sm"
			/>
		) : (
			<div className="cover-placeholder-sm">
				<div
					style={{
						fontFamily: "Newsreader, serif",
						fontSize: "15px",
						lineHeight: 1.2,
						color: "var(--fg)",
					}}
				>
					{book.title}
				</div>
			</div>
		)}
		<div>
			<div
				style={{
					fontFamily: "Newsreader, serif",
					fontSize: "25px",
					fontWeight: 400,
					lineHeight: 1.18,
					letterSpacing: "-0.018em",
					color: "var(--fg)",
				}}
			>
				{book.title}
			</div>
			<div
				className="secmeta"
				style={{ fontSize: "10px", marginTop: "10px" }}
			>
				{book.creditShort}
			</div>
			{book.accolade ? (
				<div
					style={{
						fontSize: "14.5px",
						color: "var(--accent)",
						marginTop: "10px",
					}}
				>
					{book.accolade}
				</div>
			) : (
				<a
					href={book.links[0].link}
					target="_blank"
					rel="noreferrer"
					className="link-plain"
					style={{
						display: "inline-block",
						color: "var(--fg)",
						borderBottom: "1px solid var(--rule)",
						marginTop: "12px",
					}}
				>
					{book.links[0].label}
				</a>
			)}
		</div>
	</div>
);

const Publications = () => (
	<Page page="publications" className="wrap page">
		<div className="kicker">Publications</div>
		<h1 className="h-page" style={{ maxWidth: "20ch" }}>
			Books and Research Papers
		</h1>
		<p className="p-body p-narrow" style={{ marginTop: "24px" }}>
			{PUBLICATIONS_INTRO}
			{/* Citation record on{" "}
			<a
				href={SITE.scholar}
				target="_blank"
				rel="noreferrer"
				className="link-inline"
			>
				Google Scholar
			</a>
			. */}
		</p>

		<div
			className="split-tight"
			style={{ marginTop: "clamp(48px, 7vw, 88px)" }}
		>
			{BOOKS.map((book) => (
				<CompactBook book={book} key={book.id} />
			))}
		</div>

		<Reveal className="blk">
			{PAPERS_BY_YEAR.map((group, groupIndex) => (
				<div key={group.year}>
					<div
						className={
							"year-head" +
							(groupIndex > 0 ? " year-head-spaced" : "")
						}
					>
						{group.year}
					</div>
					{group.papers.map((paper) => (
						<a
							key={paper.id}
							href={paper.link}
							target="_blank"
							rel="noreferrer"
							className="row-paper rule-bottom-soft"
						>
							<span className="paper-date">
								{paper.date ? paper.date + " · " : ""}
								{paper.venue}
							</span>
							<span className="paper-body">
								<span className="paper-title">
									{paper.title}
								</span>
								{paper.badge && (
									<span
										className="badge-accent"
										style={{
											display: "block",
											marginTop: "8px",
										}}
									>
										{paper.badge}
									</span>
								)}
							</span>
						</a>
					))}
				</div>
			))}
		</Reveal>
	</Page>
);

export default Publications;
